import { Component } from "@angular/core";
import { ALLOWED_CHARACTERS } from "src/config/allowed-characters.config";
import { PrefixComponent } from "../../prefix.component";
import { TemplateNumberComponent } from "../../templates/template-number/template-number.component";
import { Max } from "../../types/Max";

@Component({
  standalone: true,
  selector: "app-prefix-hu2",
  imports: [TemplateNumberComponent],
  templateUrl: "./prefix-hu2.component.html",
  styleUrl: "./prefix-hu2.component.less",
})
export class PrefixHu2Component extends PrefixComponent<string> {
  public max: Max;

  public constructor() {
    super({ updateOn: "blur" });
    this.max = 99999;
    this.required = true;
    this.characters = ALLOWED_CHARACTERS["hu2"];
  }
}
